import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { isEmpty, startCase, toLower } from 'lodash';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { Rupee } from 'components';
import { Box, Flex, Text } from 'atoms';
import { getDateDiff, dateValidationCheck } from 'utils';

function getBGColor(props) {
	if (props.status === 'Bill Back') {
		return props.theme.colors.YellowOrange;
	}
	if (props.status === 'No Bill Back') {
		return props.theme.colors.YellowGreen;
	}

	return props.theme.colors.primary;
}

function getTextColor(props) {
	if (props.status === 'Bill Back') {
		return props.theme.colors.Onyx;
	}

	return props.theme.colors.white;
}

function getAmountBGColor(props) {
	if (props.status === 'Bill Back') {
		return props.theme.colors.Bisque;
	}
	if (props.status === 'No Bill Back') {
		return props.theme.colors.Nyanza;
	}

	return props.theme.colors.AliceBlue;
}

const Container = styled(Box)`
	padding: 10px 20px 5px;
	border-radius: 5px;
	color: ${(props) => getTextColor(props)};
	background-color: ${(props) => getBGColor(props)};
	width: ${(props) => (props.viewOnly ? '73%' : '85%')};
	margin-left: ${(props) => (props.viewOnly ? '15%' : 'unset')};
`;

const Amount = styled(Box)`
	padding: 5px;
	border-radius: 2px;
	color: ${(props) => props.theme.colors.Jet};
	background-color: ${(props) => getAmountBGColor(props)};
	font-weight: 600;
	font-size: 12px;
`;

const BoxToolTip = styled(Box)`
	margin-left: 10px;
	color: red;
`;

export default function InvoiceInfo({ data, viewOnly = false }) {
	if (isEmpty(data)) return null;
	const {
		current_outstanding_amount = 0,
		invoice_date,
		invoice_no,
		status,
		store_name,
		late_fee_flag,
	} = data;

	return (
		<Container status={status} viewOnly={viewOnly}>
			<Flex justifyContent="space-between">
				<Box>
					<Text
						fontWeight="600"
						fontSize="10px"
						mb="10px"
						className="invoice-number"
						title="Invoice Number"
						textTransform="uppercase"
					>
						{invoice_no}
					</Text>
					<Flex justifyContent="flex-start" alignItems="center">
						<Text className="invoice-date" title="Invoice Date" fontSize="10px">
							{dateValidationCheck(invoice_date)
								? moment(invoice_date).format('DD-MM-YY')
								: 'NA'}
						</Text>
						<Text fontWeight="600" fontSize="10px" pl="1rem">
							{dateValidationCheck(invoice_date) ? getDateDiff(invoice_date) : 'NA'}{' '}
							days
						</Text>
						{late_fee_flag === 1 && (
							<Tooltip title="late collection indication">
								<BoxToolTip>
									<WarningOutlined />
								</BoxToolTip>
							</Tooltip>
						)}
					</Flex>
				</Box>
				<Box>
					<Amount
						status={status}
						title="Outstanding Amount"
						className="invoice-amount"
						data-amount={current_outstanding_amount}
					>
						<Rupee>{current_outstanding_amount}</Rupee>
					</Amount>
				</Box>
			</Flex>
			<Box mt="10px">
				<Text
					className="invoice-store-name"
					title="Store Name"
					fontWeight="600"
					fontSize="12px"
					lineHeight="16px"
				>
					{startCase(toLower(store_name))}
				</Text>
			</Box>
		</Container>
	);
}

InvoiceInfo.propTypes = {
	data: PropTypes.shape({
		current_outstanding_amount: PropTypes.string,
		invoice_date: PropTypes.string,
		invoice_no: PropTypes.string,
		status: PropTypes.string,
		store_name: PropTypes.string,
		paid: PropTypes.number,
		id: PropTypes.number,
		store_id: PropTypes.number,
		late_fee_flag: PropTypes.any,
	}),
	viewOnly: PropTypes.bool,
};
